import Dialog from "@mui/material/Dialog";
import type { Item } from "@egalregal/shared";
import type { CodeDecoder } from "../scan/scan";
import { ScannerSurface } from "../scan/ScannerSurface";

/**
 * Scanner-to-create dialog for the items list: type or scan a barcode, look it
 * up to prefill name and category, then confirm to create a standalone
 * (unplaced) item. The camera, provider lookup and form live in the shared
 * `item-create` scanner preset (scanner-surface 02); this wrapper owns only the
 * MUI dialog shell.
 *
 * A caller that already knows the barcode (a scanned QR label, qr-item-tags 01)
 * passes `initialBarcode`: the preset then opens directly in the manual phase
 * with the barcode fixed — no camera and no provider lookup.
 */
export function CreateItemDialog({
  open,
  onClose,
  onCreated,
  decoder,
  initialBarcode,
}: {
  open: boolean;
  onClose: () => void;
  /** Receives the created (or already existing) item. */
  onCreated: (item: Item) => void;
  decoder?: CodeDecoder;
  /** Barcode to start with in the manual phase, skipping scanning/lookup. */
  initialBarcode?: string;
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <ScannerSurface
        variant="item-create"
        onCreated={onCreated}
        onClose={onClose}
        initialBarcode={initialBarcode}
        decoder={decoder}
      />
    </Dialog>
  );
}
